module.exports = __webpack_public_path__ + "static/media/small-gear.1f13757a.svg";